<template>
    <!-- <iframe scrolling='auto' src='https://www.baidu.com'> 测试百度链接</iframe> -->
    <div>
      <iframe  id="bdIframe" :src="url" frameborder="0" scrolling="auto" width="100%" style="left:0"></iframe>
    </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  data () {
    return {
      url: ''
    }
  },
  mounted () {
    /**
     * iframe-宽高自适应显示
     */
    const oIframe = document.getElementById('bdIframe')
    const deviceHeight = document.documentElement.clientHeight
    oIframe.style.height = (Number(deviceHeight) - 120) + 'px'
  },
  created () {
    this.queryDictListInfoByCode()
  },
  methods: {
    ...mapActions(['queryDictListInfo']),
    queryDictListInfoByCode () { // 初始化状态数据字典
      this.queryDictListInfo({ code: 'zaitu_share_report' }).then(res => {
        // this.$message.success('初始化状态数据字典成功' + JSON.stringify(res))
        this.url = res.data[0].description
      })
    }
  }
}
</script>
<style scoped>

</style>
